import { Link } from "react-router-dom";
import { Instagram, Twitter, Youtube, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#050505] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-4">
              <img
                src="https://customer-assets.emergentagent.com/job_elite-training-hub-29/artifacts/pe71jees_5CB65146-0216-4877-B45D-E702230BD224.png"
                alt="BlueprintHoopz"
                className="h-14 w-auto"
              />
              <div className="font-display text-2xl md:text-3xl font-bold uppercase tracking-tight">
                Blueprint<span className="text-[#2563EB]">Hoopz</span>
              </div>
            </div>
            <p className="mt-4 text-[#A1A1AA] text-sm max-w-md leading-relaxed">
              The Foundation For Success. Premium basketball development for
              athletes ready to play at the next level.
            </p>
            <div className="mt-6 flex items-center gap-3 text-[#A1A1AA] text-sm">
              <MapPin size={16} className="text-[#60A5FA]" />
              Greenville / Taylors, South Carolina
            </div>
          </div>

          <div>
            <div className="font-display text-sm tracking-widest uppercase text-white/90 mb-4">
              Explore
            </div>
            <ul className="space-y-3 text-sm text-[#A1A1AA]">
              <li>
                <a href="/#about" className="hover:text-white">
                  About
                </a>
              </li>
              <li>
                <a href="/#memberships" className="hover:text-white">
                  Memberships
                </a>
              </li>
              <li>
                <a href="/#contact" className="hover:text-white">
                  Contact
                </a>
              </li>
              <li>
                <Link to="/book" className="hover:text-white">
                  Book a Session
                </Link>
              </li>
              <li>
                <Link to="/my-pack" className="hover:text-white">
                  Customer Portal
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <div className="font-display text-sm tracking-widest uppercase text-white/90 mb-4">
              Follow
            </div>
            <div className="flex items-center gap-4 text-[#A1A1AA]">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-social-instagram"
                className="hover:text-[#60A5FA]"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-social-twitter"
                className="hover:text-[#60A5FA]"
              >
                <Twitter size={20} />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-social-youtube"
                className="hover:text-[#60A5FA]"
              >
                <Youtube size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-xs tracking-wider text-[#A1A1AA] uppercase">
            © {new Date().getFullYear()} BlueprintHoopz. All rights reserved.
          </div>
          <div className="flex items-center gap-5">
            <div className="text-xs tracking-widest text-[#A1A1AA] uppercase">
              The Foundation For Success
            </div>
            <Link
              to="/admin"
              data-testid="footer-owner-login"
              className="text-[10px] tracking-[0.3em] uppercase text-white/30 hover:text-[#60A5FA] border border-white/5 hover:border-[#2563EB]/40 px-3 py-1.5 transition-colors"
            >
              Owner Login
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
